import { TableContainer } from "@mui/material";
import { Table } from "antd";
import React, { useState } from "react";
import ExportToExcel from "~/components/ExportToExcel";


const PlantData = (data) => {
    const [tableParams, setTableParams] = useState({
        pagination: {
          current: 1,
          pageSize: 25,
        },
      });
  
    const columns = [
        {
        title: "Plant English Name",
        dataIndex: "Plant_Eng_Name",
        key: "Plant_Eng_Name",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Local Name",
        dataIndex: "Plant_Local_Name",
        key: "Plant_Local_Name",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Scientific Name",
        dataIndex: "Plant_Scientific_Name",
        key: "Plant_Scientific_Name",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Category",
        dataIndex: "Plantation_Type",
        key: "Plantation_Type",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Season",
        dataIndex: "Plant_Season",
        key: "Plant_Season",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Habit",
        dataIndex: "Plant_Habit",
        key: "Plant_Habit",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Nature",
        dataIndex: "Plant_Nature",
        key: "Plant_Nature",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Description",
        dataIndex: "Plant_Desc",
        key: "Plant_Desc",
        responsive: ["lg", "md", "xl", "sm"],
        },
        {
        title: "Plant Uses",
        dataIndex: "Plant_Uses",
        key: "Plant_Uses",
        responsive: ["lg", "md", "xl", "sm"],
        },
    ];

    return (
        <>
            <ExportToExcel data={data.reportData} columns={columns} fileName="Plant Data.csv" />
            <TableContainer sx={{ boxShadow: "none" }}>
                <Table
                    scroll={{
                        x: 2500,
                        y: 500,
                    }}
                    columns={columns}
                    dataSource={data.reportData}
                    pagination={{
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                    }}
                />
            </TableContainer>
        </>
           
    );
};

export default PlantData;